import React, { useMemo, useState } from 'react';
import LoadingScreen from 'icw-components/LoadingScreen';
import { useLocation, Route, Redirect } from 'react-router-dom';
import { useMe } from 'modules/company/hooks/useCompanySelector';
import { useCookies } from 'react-cookie';
import { Layout, Image } from 'antd';
import InvitationExpired from 'modules/supplier/components/Empty/InvitationExpired';
import ICWLogo from 'assets/img/icw-logo.png';
import AppFooter from 'components/New/Footer/AppFooter';
import AppSiderWithLogin from 'components/New/Siders/AppSiderWithLogin';
import { HOME_PATH } from 'shared/routes';
import { getLocale } from 'util/icwUtility';
import { useValidateInvitationCode } from '../../hooks/useValidateInvitationCode';
import { useSupplierInvitationTrackingContext } from 'modules/supplier/context/SupplierInvitationTracking';

/**
 * View invitation
 * if user logged in navigate to list invitation view
 * otherwise create account and navigate to list invitation view
 */
const Invitation = (props) => {
  const [cookies] = useCookies();
  const { profile } = useMe();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const invitationCode = searchParams.get('code');
  const { loading, expired, validated, data, existed } = useValidateInvitationCode(invitationCode);
  const { resetTrackingState } = useSupplierInvitationTrackingContext();
  const isLoggedIn = useMemo(() => {
    return !!cookies.token;
  }, [cookies]);

  const isMatchedEmail = React.useMemo(() => {
    return profile.email === data?.email;
  }, [validated, existed]);

  const shouldNavigateToAccept = React.useMemo(() => {
    if (!validated) return false;
    return isLoggedIn && profile.email === data?.email;
  }, [validated, existed]);

  const saveInvitationToSession = () => {
    localStorage.setItem(
      'invitation',
      JSON.stringify({
        from: 'invitation',
        email: data?.email,
        invitationCode,
        companyName: data?.creatorCompanyName,
        existed,
      })
    );
  };

  React.useEffect(() => {
    if (!validated) return;
    if (isLoggedIn) return;
    //Check Exactly Link invitation match with current user email.
    saveInvitationToSession();
  }, [validated, isMatchedEmail]);

  if (!validated || loading) return <LoadingScreen />;
  if (isLoggedIn && isMatchedEmail) {
    setTimeout(() => {
      resetTrackingState();
    }, 500);
    return <Redirect to={HOME_PATH} />;
  }
  if (!isLoggedIn && validated && !expired) {
    // suppliers/invitation?code=80bcc290-8714-4038-a1aa-679c41f19146

    return (
      <Redirect
        from="/invitation"
        to={{
          pathname: `/${getLocale()}/${existed ? 'login' : 'registration'}`,
        }}
      />
    );
  }
  return (
    <Layout>
      <Layout.Sider width={415}>
        <AppSiderWithLogin showEmpty={!isLoggedIn} />
      </Layout.Sider>
      <Layout>
        <Layout.Content style={{ background: '#fff' }}>
          <InvitationExpired />
        </Layout.Content>
        <Layout.Footer>
          <AppFooter />
        </Layout.Footer>
      </Layout>
    </Layout>
  );
};

export default Invitation;
